<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Mensagens — Enviadas
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  consultar
        | ,
        strong  arquivar
        |  e
        strong  restaurar
        |  as mensagens que você enviou.

      .toast.toast-primary
        | A caixa fica no menu
        strong  Mensagens
        | , para o usuário autenticado.

      h5.h5 1. Abrir enviadas
      ol
        li No menu lateral, clique em
          strong  Mensagens
          | .
        li Na caixa, clique em
          strong  Mensagens enviadas
          | .

      h5.h5 2. Listagem
      p
        | Filtre pelo
        strong  Título
        |  e clique na lupa (
        strong  Filtrar
        | ). Cada linha mostra o título, o assunto, o destinatário (
        strong  Para
        | ) e a data de envio. O ícone é o avião de papel.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de mensagens enviadas")
      p Clique na linha para abrir a mensagem.

      h5.h5 3. Leitura
      figure.manual-figure
        img(:src="imgLeitura" alt="Leitura de mensagem enviada")
      ol
        li A tela mostra título, assunto,
          strong  De
          | ,
          strong  Enviado em
          | ,
          strong  Para
          | ,
          strong  Lido em
          |  e o texto.
        li
          strong  Lido em
          |  mostra “-” até o destinatário abrir a mensagem.
        li Anexos abrem pela miniatura. Se houver conversa anterior, use
          strong  Carregar mensagem anterior...
          | .
        li
          strong  Voltar
          |  retorna à lista. Mensagem enviada não tem o botão
          strong  Responder
          | .

      h5.h5 4. Arquivar e restaurar
      ol
        li Clique em
          strong  Arquivar
          |  e confirme
          strong  Deseja arquivar a mensagem?
          |  com
          strong  Sim
          | .
        li A mensagem sai da aba
          strong  Mensagens
          |  e aparece em
          strong  Arquivadas
          | .
        li Em
          strong  Arquivadas
          | , abra a mensagem e clique em
          strong  Restaurar
          | . Confirme
          strong  Deseja restaurar a mensagem?
          |  para devolvê-la à lista de enviadas.
      p Arquivar uma enviada não remove a cópia da caixa de quem recebeu.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/47-mensagens-enviadas-lista.png"),
      imgLeitura: require("@/assets/manuais/47a-mensagens-enviadas-leitura.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
